(function(){
  try{
    var css = ''
      + '[id*="marquee_trust"]{display:none !important;}'
      + '.rp-tb{background:#ffffff;border-top:1px solid #e7e5e0;border-bottom:1px solid #e7e5e0;}'
      + '.rp-tb__in{display:flex;align-items:center;justify-content:center;padding:13px 14px;'
      + 'font-family:"SFMono-Regular",ui-monospace,Menlo,Consolas,"Liberation Mono",monospace;'
      + 'font-size:12px;line-height:1;text-transform:uppercase;letter-spacing:.2em;color:#141414;text-align:center;}'
      + '.rp-tb__more{display:inline-flex;align-items:center;}'
      + '.rp-tb__d{padding:0 22px;opacity:.45;}'
      + '.rp-tb__i{white-space:nowrap;}'
      + '[id*="marquee_brands"]{background:#ffffff !important;border-top:1px solid #ededed !important;border-bottom:1px solid #ededed !important;}'
      + '[id*="marquee_brands"],[id*="marquee_brands"] p,[id*="marquee_brands"] span,[id*="marquee_brands"] a,[id*="marquee_brands"] h2,[id*="marquee_brands"] h3{color:#111111 !important;}'
      + '[id*="marquee_brands"] .marquee,[id*="marquee_brands"] marquee-component,[id*="marquee_brands"] .marquee__wrapper{background:transparent !important;}'
      + '[id*="marquee_brands"] img,[id*="marquee_brands"] svg{filter:brightness(0) !important;opacity:.85;transition:opacity .2s ease;}'
      + '[id*="marquee_brands"] svg *{fill:#111111 !important;stroke:#111111 !important;}'
      + '[id*="marquee_brands"] img:hover,[id*="marquee_brands"] svg:hover{opacity:1;}'
      + '.collection-card{position:relative;}'
      + '.rp-catB{position:absolute;inset:0;z-index:4;pointer-events:none;}'
      + '.rp-catB__over{position:absolute;left:22px;top:20px;color:#111;font-size:10px;font-weight:800;letter-spacing:.2em;text-transform:uppercase;text-shadow:0 1px 10px rgba(255,255,255,.92),0 0 2px rgba(255,255,255,.92);}'
      + '.rp-catB__title{position:absolute;left:22px;bottom:56px;max-width:82%;pointer-events:auto;text-decoration:none;color:#ffffff;font-size:26px;font-weight:800;line-height:1.02;text-transform:uppercase;letter-spacing:-.01em;text-shadow:0 2px 16px rgba(0,0,0,.5),0 0 4px rgba(0,0,0,.45),0 0 18px rgba(255,255,255,.45),0 0 6px rgba(255,255,255,.35);}'
      + '.rp-catB__shop{position:absolute;left:22px;bottom:22px;pointer-events:auto;color:#ccff33;font-size:11px;font-weight:800;letter-spacing:.14em;text-transform:uppercase;text-decoration:none;border-bottom:1.5px solid #ccff33;padding-bottom:3px;text-shadow:0 1px 10px rgba(0,0,0,.55),0 0 12px rgba(255,255,255,.4);}'
      + '.hero__content-wrapper a[href*="/collections/all"],.hero__content-wrapper a[href*="/collections/best-sellers"]{background:#ffffff !important;border:none !important;border-radius:999px !important;}'
      + '.hero__content-wrapper a[href*="/collections/all"],.hero__content-wrapper a[href*="/collections/all"] *,.hero__content-wrapper a[href*="/collections/best-sellers"],.hero__content-wrapper a[href*="/collections/best-sellers"] *{color:#111111 !important;}'
      + '@media(max-width:749px){.rp-tb__more{display:none;}.rp-tb__in{font-size:11px;letter-spacing:.15em;padding:12px 10px;}.rp-catB__title{font-size:21px;bottom:50px;}}';
    var st=document.createElement('style'); st.textContent=css; (document.head||document.documentElement).appendChild(st);

    function trustBar(){
      if(document.querySelector('.rp-tb')) return;
      var bar=document.createElement('div'); bar.className='rp-tb';
      bar.innerHTML='<div class="rp-tb__in">'
        + '<span class="rp-tb__i">Free Shipping Worldwide</span>'
        + '<span class="rp-tb__more">'
        + '<span class="rp-tb__d">&bull;</span><span class="rp-tb__i">100% Authentic</span>'
        + '<span class="rp-tb__d">&bull;</span><span class="rp-tb__i">Secure Payment</span>'
        + '<span class="rp-tb__d">&bull;</span><span class="rp-tb__i">Customer Care</span>'
        + '</span>'
        + '</div>';
      var mq=document.querySelector('[id*="marquee_trust"]');
      if(mq&&mq.parentNode){ mq.parentNode.insertBefore(bar, mq); }
      else{
        var header=document.querySelector('header');
        if(header&&header.parentNode){ header.parentNode.insertBefore(bar, header.nextSibling); }
        else if(document.body){ document.body.insertBefore(bar, document.body.firstChild); }
      }
    }

    function catPills(){
      if(!/^\/(index)?$/.test(location.pathname) && location.pathname!=='/') return;
      document.querySelectorAll('.collection-card').forEach(function(card){
        if(card.querySelector('.rp-catB')) return;
        var link=card.querySelector('a.collection-card__link')||card.querySelector('a[href]');
        var href=(link&&link.getAttribute('href'))||'';
        if(href.indexOf('/collections')===-1) return;
        var name=/road|training/i.test(href)?'Road Running':/racing|race/i.test(href)?'Race Day':/trail/i.test(href)?'Trail':/lifestyle/i.test(href)?'Lifestyle':'';
        if(!name){ var vh=card.querySelector('.visually-hidden'); name=vh?vh.textContent.trim():'Shop'; }
        var content=card.querySelector('.collection-card__content'); if(content) content.style.display='none';
        var ov=document.createElement('div'); ov.className='rp-catB';
        ov.innerHTML='<a class="rp-catB__title" href="'+href+'">'+name+'</a>'
          + '<a class="rp-catB__shop" href="'+href+'">Shop &rarr;</a>';
        card.appendChild(ov);
      });
    }

    function build(){ trustBar(); catPills(); }
    if(document.readyState==='loading') document.addEventListener('DOMContentLoaded', build); else build();
    document.addEventListener('shopify:section:load', build);
  }catch(e){}
})();
